import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RectangleStackIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { isAtsAvailable, isRelevanterAvailable } from '../../ats/atsConfig';
import { useBrandingColors } from '../../hooks/useBrandingColors';
import { useBrandingStore } from '../../store/brandingStore';

const moduleLinkBase =
  'flex items-center gap-2 rounded-[10px] px-3 py-2 text-[14px] font-medium transition-colors';

export function SidebarModuleSwitcher() {
  const colors = useBrandingColors();
  const location = useLocation();
  const { companyData, loadCompanyData } = useBrandingStore();

  React.useEffect(() => {
    if (!companyData) {
      loadCompanyData().catch(() => {});
    }
  }, [companyData, loadCompanyData]);

  const modules = [
    {
      id: 'relevanter',
      label: 'Релевантер',
      to: '/recruiter/vacancy',
      Icon: RectangleStackIcon,
      enabled: isRelevanterAvailable(companyData),
    },
    {
      id: 'ats',
      label: 'ATS',
      to: '/ats',
      Icon: UserGroupIcon,
      enabled: isAtsAvailable(companyData),
    },
  ].filter((module) => module.enabled);

  return (
    <div className="px-5 py-4 border-b border-sidebar-border">
      <div className="flex flex-col gap-1">
        {modules.map(({ id, label, to, Icon }) => {
          const isActive =
            id === 'ats'
              ? location.pathname === '/ats' || location.pathname.startsWith('/ats/')
              : location.pathname.startsWith('/recruiter') &&
                !location.pathname.startsWith('/ats/');

          return (
            <Link
              key={id}
              to={to}
              data-testid={`sidebar-module-${id}`}
              className={`${moduleLinkBase} ${
                isActive
                  ? 'bg-white text-[var(--text-dark)] shadow-sm'
                  : 'text-[var(--text-medium)] hover:bg-white/60 hover:text-[var(--text-dark)]'
              }`}
              style={isActive ? { color: colors.primary } : undefined}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span>{label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
